import setHeader from '@/shared/utils/setHeader';

const createFetchFn =
  (context: { token?: string; endpoint: string }) =>
  (query: string, variables: Record<string, unknown>) => {
    const { endpoint, token } = context;
    return fetch(endpoint, {
      method: 'POST',
      body: JSON.stringify({ query, variables }),
      redirect: 'follow',
      headers: {
        ...setHeader(`Authorization`, token, () => `Bearer ${token}`),
        'Content-Type': 'application/json',
      },
    });
  };

export default createFetchFn;
